import { Box, Typography } from '@mui/material';
import type { ReactElement } from 'react';

interface BespokePlanCardProps {
  domain?: string | null;
}

export function BespokePlanCard({ domain }: BespokePlanCardProps): ReactElement {
  return (
    <Box className="vtwo:rounded-xl vtwo:border-2 vtwo:border-plus-border vtwo:bg-white vtwo:p-6 vtwo:flex vtwo:flex-col vtwo:gap-3">
      <Box className="vtwo:flex vtwo:flex-col vtwo:gap-3">
        <Typography className="vtwo:text-2xl vtwo:font-semibold vtwo:tracking-tight vtwo:text-typography-primary">
          You are using the Bespoke plan
        </Typography>
        <Typography className="vtwo:text-sm vtwo:text-gray-600" hidden>
          What does it means for customer
        </Typography>
      </Box>

      <Box className="vtwo:h-px vtwo:bg-[#eef0ef]" />

      <Box className="vtwo:flex vtwo:flex-col vtwo:gap-3">
        {domain && (
          <Typography className="vtwo:text-base vtwo:text-typography-primary">{domain}</Typography>
        )}
        <Typography className="vtwo:text-sm vtwo:text-gray-600">
          If you want to apply changes on your website,{' '}
          <a
            href="mailto:sales@healthera.co.uk"
            className="vtwo:underline vtwo:cursor-pointer focus-ring vtwo:rounded"
          >
            contact your CSM
          </a>
        </Typography>
      </Box>
    </Box>
  );
}
